import React from 'react';

import { Box, Text } from '@rbilabs/universal-components';
import { useRouter } from 'expo-router';
import { useIntl } from 'react-intl';

import { ArrowButton } from 'components/arrow-button';
import { ArrowLink } from 'components/arrow-link';
import useDialogModal from 'hooks/use-dialog-modal';
import { routes } from 'navigation/routing';
import { CustomEventNames, logNavigationClick } from 'state/amplitude';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';

const LinkContainer = Box.withConfig({
  marginTop: '$1',
});

export const TermsSection = () => {
  const enableAccountDeleteOneTrust = useFlag(LaunchDarklyFlag.ENABLE_ACCOUNT_DELETE_ONE_TRUST);

  const { formatMessage } = useIntl();
  const router = useRouter();

  const [Confirm, openConfirm] = useDialogModal<{ id: string }>({
    onConfirm: () => {
      logNavigationClick(CustomEventNames.BUTTON_CLICK_SIGN_OUT);
      router.replace(routes.signOut);
    },
    showCancel: true,
    modalAppearanceEventMessage: 'Confirmation: Sign Out',
  });

  return (
    <LinkContainer>
      <ArrowLink to={routes.privacyPolicy}>{formatMessage({ id: 'privacyPolicy' })}</ArrowLink>

      <ArrowLink to={routes.termsOfService}>{formatMessage({ id: 'termsOfService' })}</ArrowLink>

      {/* @ts-expect-error TS(2322) FIXME: Type 'DialogCb<{ id: string; }>' is not assignable... Remove this comment to see the full error message */}
      <ArrowButton onPress={openConfirm} testID="signout-button">
        <Text>{formatMessage({ id: 'signOut' })}</Text>
      </ArrowButton>
      {/* TODO Remove one legal approves the use of `enableAccountDeletePage` */}
      {enableAccountDeleteOneTrust && (
        <ArrowLink
          isExternal
          to={
            'https://privacyportal-eu-cdn.onetrust.com/dsarwebform/7ae425dd-1c76-46b0-a1b4-2422a364fae3/draft/1d4481aa-204a-4cb5-a40a-82e4369d16b2.html'
          }
          eventName={CustomEventNames.BUTTON_CLICK_ACCOUNT_DELETE_ONE_TRUST}
        >
          {formatMessage({ id: 'deleteAccount' })}
        </ArrowLink>
      )}

      <Confirm
        heading={formatMessage({ id: 'signOut' })}
        body={formatMessage({ id: 'signOutConfirmSubheader' })}
        confirmLabel={formatMessage({ id: 'yes' })}
        cancelLabel={formatMessage({ id: 'no' })}
      />
    </LinkContainer>
  );
};
